import React from 'react';
import { ArrowShortLeftIcon } from '@fourthwall/icons';
import { ButtonClean } from '../ButtonClean';
export const BackButton = ({ label, to, state }) => {
    return (React.createElement(ButtonClean, { label: label, icon: ArrowShortLeftIcon, to: to, state: state, appearance: "secondary", withUnderline: false }));
};
